import { useEffect, useMemo, useSyncExternalStore } from 'react';
import { useAuthController } from '../useAuthController';
import { getUserSetting, setUserSetting, resetUserSetting } from '../rpc';
import { UserSettingController, type UserSettingOptions } from './UserSettingController';

const transport = { get: getUserSetting, set: setUserSetting, reset: resetUserSetting };

/** defaultValue, decode и loadDefaults должны иметь стабильные ссылки. */
export function useUserSetting<T>(key: string, options: UserSettingOptions<T>) {
  const userId = useAuthController(state => state.user?.id);
  const { defaultValue, decode, loadDefaults } = options;
  const controller = useMemo(
    () => new UserSettingController(key, { defaultValue, decode, loadDefaults }, transport),
    [userId, key, defaultValue, decode, loadDefaults]
  );
  const state = useSyncExternalStore(
    controller.subscribe,
    controller.getSnapshot,
    controller.getSnapshot
  );
  useEffect(() => {
    if (userId != null) void controller.reload();
    return controller.cancel;
  }, [controller, userId]);
  return {
    ...state,
    setValue: controller.setValue,
    reset: controller.reset,
    reload: controller.reload,
  };
}
